import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Menu, X, Search } from 'lucide-react';
import { Sidebar } from '../Sidebar/Sidebar';
import styles from './AppLayout.module.css';

export function AppLayout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className={styles.container}>
      {/* Desktop Sidebar */}
      <div className={styles.desktopSidebar}>
        <Sidebar />
      </div>

      {/* Mobile Drawer */}
      <div
        className={`${styles.mobileOverlay} ${mobileMenuOpen ? styles.mobileOverlayVisible : ''}`}
      >
        <div className={styles.backdrop} onClick={() => setMobileMenuOpen(false)} />
        <div className={`${styles.drawer} ${mobileMenuOpen ? styles.drawerOpen : ''}`}>
          <div className={styles.drawerInner}>
            <div className={styles.drawerHeader}>
              <div className={styles.drawerLogoRow}>
                <div className={styles.drawerLogoIcon}>
                  <Search className={styles.drawerSearchIcon} />
                </div>
                <span className={styles.drawerLogoText}>Leads Manager</span>
              </div>
              <button onClick={() => setMobileMenuOpen(false)} className={styles.drawerCloseBtn}>
                <X className={styles.drawerCloseIcon} />
              </button>
            </div>
            <Sidebar className={styles.drawerSidebar} onClose={() => setMobileMenuOpen(false)} />
          </div>
        </div>
      </div>

      <div className={styles.mainWrapper}>
        {/* Mobile Header */}
        <header className={styles.mobileHeader}>
          <div className={styles.mobileHeaderInner}>
            <button onClick={() => setMobileMenuOpen(true)} className={styles.hamburger}>
              <Menu className={styles.hamburgerIcon} />
            </button>
            <div className={styles.mobileLogoRow}>
              <div className={styles.mobileLogoIcon}>
                <Search className={styles.mobileSearchIcon} />
              </div>
              <span className={styles.mobileLogoText}>Leads Manager</span>
            </div>
          </div>
        </header>

        <main className={styles.mainContent}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
